import {Row, Space} from 'antd';
import TickerChip from "../../components/TickerChip";



const TickerBanner = ({ticker})=>{
    return (
        <Row>
            <Space>
                <TickerChip ticker={ticker}/>
            </Space>
        </Row>
    )
}


export default TickerBanner;